import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DashboardKpiService, SalesSummaryCardComponent } from 'gung-dashboard';
import { ProductService } from 'gung-standard';
import { forkJoin, first, of } from 'rxjs';

@Component({
  selector: 'cult-cult-sales-summary-card',
  templateUrl: './cult-sales-summary-card.component.html',
  styleUrls: ['./cult-sales-summary-card.component.scss']
})
export class CultSalesSummaryCardComponent extends SalesSummaryCardComponent implements OnInit {
  constructor(
    protected changeDetectorRef: ChangeDetectorRef,
    protected dashboardKpiService: DashboardKpiService,
    protected translateService: TranslateService,
    protected productService: ProductService
  ) {
    super(changeDetectorRef, dashboardKpiService, translateService, productService);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  protected fetchSalesSummaries() {
    const isToShowPreviousTimeSpan = this.getIsShowPreviousTimeSpan();

    const dateSpan = this.dashboardKpiService.getDateFromTimespan(this.currentTimespan);
    const previousDateSpan = this.dashboardKpiService.getDateFromTimespan(this.getPreviousTimeSpan());

    forkJoin({
      salesSummaryGroups: this.dashboardKpiService
        .getSalesSummary(this.currentGroupOn, dateSpan.fromDate, dateSpan.toDate, this.preConditions)
        .pipe(first()),
      previousSalesSummaryGroups: isToShowPreviousTimeSpan
        ? this.dashboardKpiService
            .getSalesSummary(
              this.currentGroupOn,
              previousDateSpan.fromDate,
              previousDateSpan.toDate,
              this.preConditions
            )
            .pipe(first())
        : of(null)
    }).subscribe(({ salesSummaryGroups, previousSalesSummaryGroups }) => {
      this.salesSummaryGroups = salesSummaryGroups;
      this.dataSource.data = this.salesSummaryGroups;

      // If is to show the previous values
      // create the data map for the previous values
      // the map will contains the data for the ids in the salesSummaryGroups (which is the dataSource of the table)
      // and the goal is to get the previous values against each table row (current time span)
      if (isToShowPreviousTimeSpan) {
        this.previousTimespanSalesSummaryGroups = {};

        for (const salesSummaryGroup of salesSummaryGroups) {
          const previousValue = previousSalesSummaryGroups.find(previous => previous.id === salesSummaryGroup.id);
          this.showDetails[salesSummaryGroup.id] = false;
          this.details[salesSummaryGroup.id] = { color: 'UNDEFINED', size: 'UNDEFINED', img: 'UNDEFINED' };
          /*  this.details[salesSummaryGroup.id] = {color: '', size: '', img: ''}; */
          if (!!previousValue) {
            this.previousTimespanSalesSummaryGroups[salesSummaryGroup.id] = previousValue;
          } else {
            this.previousTimespanSalesSummaryGroups[salesSummaryGroup.id] = {
              ...salesSummaryGroup,
              totalAmount: 0,
              totalQuantity: 0
            };
          }
        }
      }

      this.showPreviousTimeSpan = isToShowPreviousTimeSpan;
    });
  }
}
